import styles from "./DesignIdeaCategoryLongBody.module.css";
import { useState } from "react";
import { IdiSeoData } from "../../../interfaces";

type props = {
  seoData: IdiSeoData | any
}
export function DesignIdeaCategoryLongBody({ seoData }: props) {
  const [readMore, setReadMore] = useState(false);
  if (!seoData || !seoData.long_form_content || !seoData.FAQ || !seoData.FAQ.FAQ) return null;
  return (
    <section className={`${styles.readMore} bgGray`}>
      <div className="container">
        <div className={`${styles.lowerContnt} ${readMore ? styles.fullHeight : null}`} >
          <div
            className={`${styles.loginBodyContent} `}
            dangerouslySetInnerHTML={{ __html: seoData && seoData.long_form_content }}
          >
          </div>
          <div className={`${styles.loginBodyContent}`}>
            <h2>{seoData.FAQ.faq_title}</h2>
            {seoData.FAQ.FAQ?.map((f: { question: string, answer: string }, index: number) => (
              <div key={index}>
                <h3 className={styles.faqsReadmore}>
                  {f.question}
                </h3>
                <span dangerouslySetInnerHTML={{ __html: f.answer }}>
                </span>
              </div>
            ))}
          </div>
        </div>
        <span className={styles.link} onClick={() => setReadMore(!readMore)}>
          Read {readMore ? "Less" : "More.."}
        </span>
      </div>
    </section>
  );
}
